import { configureStore } from '@reduxjs/toolkit';
import authReducer, { initialCheckData } from "./slices/authReducer";
import AlertReducer from "./slices/alertSlices";


// Create the store
const store = configureStore({
  reducer: {
    authUser: authReducer,

    alert:AlertReducer,
  },
  devTools: process.env.NODE_ENV === 'development',
});

// Type for the root state
export type RootState = ReturnType<typeof store.getState>;

// Type for the dispatch function
export type AppDispatch = typeof store.dispatch;

// Dispatch an action with type safety
store.dispatch(initialCheckData() as any);

export default store;
